import { api } from "@/api"

import { queryClient } from "@/queryClient"

export const deleteProduct = async (
  productId: string
): Promise<undefined> => {
  await api.delete(`/products/products/${productId}/`)
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCTS_QUERY_KEY],
  })
  return
}
